exports.Daterangepicker = require('./lib/daterangepicker/daterangepicker.module').Daterangepicker;
exports.DaterangePickerComponent = require('./lib/daterangepicker/daterangepicker.component').DaterangePickerComponent;
exports.DaterangepickerConfig = require('./lib/daterangepicker/config.service').DaterangepickerConfig;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/ng2-daterangepicker/index.js
// module id = ../../../../ng2-daterangepicker/index.js
// module chunks = 4